// extracted by mini-css-extract-plugin
export default {"card":"QuestionGeneratorForm_card__Cna9c","input":"QuestionGeneratorForm_input__n06zr"};